<nav class="weather-navigation">
  <div class="nav nav-tabs" id="nav-tab" role="tablist"  >
    {#if $fiveDayData}
      {#each $fiveDayData as day, index}
        <a
          class="nav-link d-flex"
          id="nav-{index}-tab"
          href="javascript:void(0)"
          role="tab"
          aria-selected="true"
          on:click="{() => cityOptions.changeTab(index,day)}"
          class:active="{day.selected}"
        >
        
          <div class="weather-day">
            <strong class="d-none d-md-inline">{day.date_name}</strong>
            <strong class="d-inline d-md-none">{day.short_date_name}</strong>
            <br />
            <span class="small muted d-none d-lg-inline">{day.fullDate}</span>
          </div>
          <div class="d-lg-none" style="flex-basis: 100%; height: 0;"></div>
          <div class="ml-lg-3">
            <img
            class="weather-icon "
            src="https://img.rtvslo.si/_static/novi/bootstrap/public/img/weather-widget/{iconConverter.convert(day.icon)}.svg"
            alt="{(day.icon_text)}"
          />
           <!-- <svg
              class="weather-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 100"
              xml:space="preserve"
              ><path
                d="M82.4 50.6c0 6.5-2.7 12.3-6.9 16.5-2-2.5-5.1-4.2-8.9-4.2a12.3 12.3 0 0 0-17.7-13.5 16 16 0 0 0-8.8-10 22.6 22.6 0 0 1 42.3 11.2zM59.7 22.7a2.5 2.5 0 0 1-2.5-2.5v-7.6c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v7.6c.1 1.4-1.1 2.5-2.5 2.5zm37.8 30.4h-7.6a2.5 2.5 0 0 1-2.5-2.5c0-1.4 1.1-2.5 2.5-2.5h7.6c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5zM81.1 31.6c-2.2 0-3.4-2.7-1.8-4.3l5.3-5.4c1-1 2.6-1 3.6 0s1 2.6 0 3.6l-5.3 5.4c-.5.5-1.2.7-1.8.7zm5.3 48.5c-.6 0-1.3-.2-1.8-.7L79.3 74c-1-1-1-2.6 0-3.6s2.6-1 3.6 0l5.3 5.4c1.6 1.5.4 4.3-1.8 4.3zm-48-48.5c-.6 0-1.3-.2-1.8-.7l-5.3-5.4c-1-1-1-2.6 0-3.6s2.6-1 3.6 0l5.3 5.4c1.6 1.6.4 4.3-1.8 4.3z"
                fill="#f0c314"></path><path
                d="M62.6 67.6a12.3 12.3 0 0 0-17.7-13.5c-2-6.6-8.1-11.5-15.3-11.5a16 16 0 0 0-15.9 17.6A15 15 0 0 0 14.8 90h48c6.1 0 11.1-5 11.1-11.2 0-5.9-4.6-11.2-11.3-11.2z"
                fill="#dce1eb"></path></svg
            > -->
          </div>
          <div class="d-sm-none" style="flex-basis: 100%; height: 0;"></div>
          <div class="ml-sm-3">
            <strong>{day.maxTemp}</strong><br />
            <span class="font-weight-light">{day.minTemp}</span>
          </div>
        </a>
      {/each}
    {/if}
  </div>
</nav>

<script lang="ts">
  import { weatherStore } from "../store";
  const { fiveDayData } = weatherStore;
  import {cityOptions} from "./../services/CityOptions"
  import {iconConverter} from "./../services/IconConverter"
  /*function changeTab(index: number){
    console.log('index', index)
    switch (index) {
      case 0:
        
        break;
      case 1:
        
        break;  
      default:
        break;
    }
  } */
</script>
